import React, { FC } from 'react';
import styles from './SitePreview.scss';
import { MobileDevice } from 'components/MobileDevice/MobileDevice';
import { BrowserFrame } from '@wix/gg-common-lib/components';

type Props = {
  url: string;
  mobileImageSrc: string;
};

export const SitePreview: FC<Props> = ({ url, mobileImageSrc }) => {
  return (
    <div className={styles.sitePreview}>
      <div className={styles.sitePreviewMobile}>
        <MobileDevice>
          <img className={styles.sitePreviewMobileImage} src={mobileImageSrc} alt="Mobile preview" />
        </MobileDevice>
      </div>
      <div className={styles.sitePreviewBrowser}>
        <BrowserFrame>
          <div className={styles.sitePreviewIframe}>
            <iframe src={url} title="Site preview" />
          </div>
        </BrowserFrame>
      </div>
    </div>
  );
};
